import React from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';

const Section = ({ title, children, id }) => (
  <section id={id} className="mb-10" data-testid={`privacy-section-${id}`}>
    <h2 className="text-2xl font-bold text-[#1E3A5F] mb-3 border-l-4 border-[#5BC5D4] pl-4">{title}</h2>
    <div className="text-gray-700 leading-relaxed text-sm space-y-3">{children}</div>
  </section>
);

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="privacy-page">
      <PageBanner title="Politique de confidentialité" subtitle="Protection de vos données personnelles (RGPD)" />
      <div className="container-custom py-10 max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-sm p-6 md:p-10">
          <p className="text-xs text-gray-500 italic mb-8">
            Dernière mise à jour : avril 2026 — Document conforme au Règlement Général sur la Protection des Données (UE 2016/679) et à la Loi Informatique et Libertés modifiée.
          </p>

          <Section id="qui" title="1. Qui sommes-nous ?">
            <p>L'association <strong>Rhône Alpes Amitié Voyages (RAAV)</strong> est responsable du traitement de vos données personnelles collectées via le site <strong>www.rhoneamitievoyages.fr</strong>.</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Forme juridique : Association loi 1901</li>
              <li>SIRET : 50511550100015</li>
              <li>TVA intracommunautaire : FR02505115501</li>
              <li>Immatriculation Tourisme : IMO75100069 (par affiliation FNGM)</li>
              <li>Adresse du siège : <strong>3 rue Victor-Hugo, 69800 Saint-Priest</strong></li>
              <li>Responsable de publication : <strong>M. Hassani Kamel</strong>, Président de l'association</li>
              <li>Responsable RGPD (DPO) : <strong>M. Hassani Kamel</strong></li>
              <li>Contact RGPD : <a href="mailto:rhoneamitie@gmail.com" className="text-[#5BC5D4] hover:underline">rhoneamitie@gmail.com</a> — 06 60 41 62 18</li>
            </ul>
          </Section>

          <Section id="donnees" title="2. Quelles données collectons-nous ?">
            <p>Lorsque vous vous inscrivez à un voyage ou que vous nous contactez, nous collectons les données suivantes :</p>
            <div className="grid md:grid-cols-2 gap-3 mt-3">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Identité</h4>
                <p className="text-xs">Nom, prénom, date de naissance, sexe</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Coordonnées</h4>
                <p className="text-xs">Adresse postale, email, téléphone (mobile et/ou WhatsApp)</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Pièces d'identité</h4>
                <p className="text-xs">CNI / passeport (numéro, validité) — uniquement pour les voyages avion / hors UE</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Données de paiement</h4>
                <p className="text-xs">Historique des règlements (mode, montant, date) — aucune donnée bancaire (CB) n'est stockée sur notre site</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Données voyage</h4>
                <p className="text-xs">Choix de chambre, voyageur(s) accompagnant(s), lieu de départ autocar, formalités</p>
              </div>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <h4 className="font-bold text-[#1E3A5F] mb-1">Adhésion / Assurance</h4>
                <p className="text-xs">Statut d'adhérent, choix d'assurance multirisque</p>
              </div>
            </div>
          </Section>

          <Section id="finalites" title="3. Pourquoi collectons-nous ces données ?">
            <p>Vos données sont collectées exclusivement pour les finalités suivantes :</p>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Gestion de votre inscription</strong> à un voyage (établissement du contrat, organisation logistique : autocar, chambre, formalités)</li>
              <li><strong>Émission de la facture</strong> et suivi des règlements</li>
              <li><strong>Souscription d'assurance multirisque</strong> auprès de notre partenaire (Groupama) si vous le demandez</li>
              <li><strong>Communication directe</strong> (email, WhatsApp) sur l'organisation pratique du voyage et les actualités de l'association</li>
              <li><strong>Obligations légales et comptables</strong> (conservation des factures, déclarations fiscales)</li>
              <li><strong>Sécurité du voyage</strong> (formalités auprès des compagnies aériennes, listes de passagers, contact d'urgence)</li>
            </ul>
          </Section>

          <Section id="base-legale" title="4. Base légale du traitement">
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Exécution du contrat</strong> : la majorité des données sont nécessaires à la réalisation de votre voyage (art. 6.1.b RGPD)</li>
              <li><strong>Obligation légale</strong> : conservation des factures et pièces comptables (art. 6.1.c RGPD)</li>
              <li><strong>Consentement</strong> : pour l'envoi d'actualités/newsletters non liées à un voyage en cours (art. 6.1.a RGPD) — vous pouvez retirer votre consentement à tout moment</li>
              <li><strong>Intérêt légitime</strong> : prévention de la fraude, sécurité du site (art. 6.1.f RGPD)</li>
            </ul>
          </Section>

          <Section id="destinataires" title="5. À qui sont transmises vos données ?">
            <p>Vos données sont strictement réservées à :</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Le bureau de l'association (président, bénévoles autorisés)</li>
              <li><strong>Groupama</strong> (assureur multirisque) — uniquement si vous souscrivez l'assurance, et uniquement les données nécessaires</li>
              <li><strong>Compagnies aériennes / autocaristes</strong> — listes de passagers obligatoires (nom, prénom, date de naissance, n° pièce d'identité pour vols)</li>
              <li><strong>Hébergeur du site</strong> (Emergent) — stockage technique sécurisé</li>
              <li><strong>Service d'envoi d'emails</strong> (Resend) — envoi des factures et confirmations</li>
            </ul>
            <p className="font-semibold text-[#1E3A5F]">Nous ne vendons jamais vos données. Nous ne les transmettons à aucun tiers commercial.</p>
          </Section>

          <Section id="duree" title="6. Combien de temps conservons-nous vos données ?">
            <table className="w-full text-xs border-collapse mt-2">
              <thead>
                <tr className="bg-[#1E3A5F] text-white">
                  <th className="px-3 py-2 text-left">Type de données</th>
                  <th className="px-3 py-2 text-left">Durée de conservation</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200"><td className="px-3 py-2">Données d'inscription voyageur</td><td className="px-3 py-2">5 ans après le dernier voyage</td></tr>
                <tr className="border-b border-gray-200 bg-gray-50"><td className="px-3 py-2">Factures et pièces comptables</td><td className="px-3 py-2">10 ans (obligation légale fiscale)</td></tr>
                <tr className="border-b border-gray-200"><td className="px-3 py-2">Pièces d'identité scannées</td><td className="px-3 py-2">Suppression après le retour du voyage</td></tr>
                <tr className="border-b border-gray-200 bg-gray-50"><td className="px-3 py-2">Email de contact (sans inscription)</td><td className="px-3 py-2">3 ans après le dernier échange</td></tr>
                <tr><td className="px-3 py-2">Newsletter / actualités</td><td className="px-3 py-2">Jusqu'à votre désinscription</td></tr>
              </tbody>
            </table>
          </Section>

          <Section id="droits" title="7. Vos droits">
            <p>Conformément au RGPD et à la Loi Informatique et Libertés, vous disposez des droits suivants sur vos données :</p>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>Droit d'accès</strong> : obtenir une copie de toutes les données que nous détenons sur vous</li>
              <li><strong>Droit de rectification</strong> : corriger une donnée erronée ou obsolète</li>
              <li><strong>Droit à l'effacement</strong> (« droit à l'oubli ») : demander la suppression de vos données, sous réserve des obligations légales (factures conservées 10 ans)</li>
              <li><strong>Droit à la limitation</strong> : geler temporairement le traitement de vos données</li>
              <li><strong>Droit à la portabilité</strong> : recevoir vos données dans un format structuré pour les transmettre à un autre prestataire</li>
              <li><strong>Droit d'opposition</strong> : refuser certains traitements (ex. newsletter)</li>
              <li><strong>Droit de retirer votre consentement</strong> à tout moment (pour les traitements basés sur le consentement)</li>
            </ul>
            <div className="bg-amber-50 border-2 border-amber-300 rounded-lg p-4 mt-4">
              <p className="font-bold text-amber-900 mb-1">📧 Comment exercer vos droits ?</p>
              <p className="text-amber-800 text-sm">Adressez votre demande par email à <a href="mailto:rhoneamitie@gmail.com" className="font-bold underline">rhoneamitie@gmail.com</a> en précisant votre nom, prénom, et la nature de votre demande. Nous répondons sous <strong>30 jours maximum</strong>.</p>
              <p className="text-amber-700 text-xs mt-2">Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer" className="font-bold underline">CNIL</a>.</p>
            </div>
          </Section>

          <Section id="securite" title="8. Sécurité de vos données">
            <p>Nous mettons en œuvre des mesures techniques et organisationnelles adaptées :</p>
            <ul className="list-disc ml-6 space-y-1">
              <li>Connexion HTTPS chiffrée sur l'ensemble du site</li>
              <li>Base de données hébergée chez un prestataire conforme (UE/RGPD)</li>
              <li>Accès admin protégé par mot de passe et rôles différenciés (président / bénévole)</li>
              <li>Sauvegardes régulières chiffrées</li>
              <li>Aucune donnée bancaire (CB, IBAN) stockée sur le site</li>
            </ul>
          </Section>

          <Section id="cookies" title="9. Cookies">
            <p>Notre site utilise <strong>uniquement des cookies techniques essentiels</strong> au fonctionnement (session admin, authentification). Aucun cookie de suivi publicitaire ou d'analyse comportementale n'est déposé sans votre consentement.</p>
          </Section>

          <Section id="modifications" title="10. Modifications de cette politique">
            <p>Nous pouvons être amenés à modifier cette politique pour rester en conformité avec l'évolution de la réglementation. Toute modification substantielle vous sera notifiée par email.</p>
          </Section>

          <div className="border-t-2 border-gray-200 pt-6 mt-10 text-center">
            <p className="text-sm text-gray-600 mb-3">Pour toute question, n'hésitez pas à nous contacter :</p>
            <Link to="/contact" className="inline-block bg-[#5BC5D4] text-white px-6 py-3 rounded-xl font-bold hover:bg-[#4AB4C3] transition" data-testid="privacy-contact-cta">
              📧 Nous contacter
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
